import type { EpisodeOfCare } from "@rmh/defs";
import dayjs from "dayjs";
import { getEpisodeOfCareStatus } from "./getEpisodeOfCareStatus";

export const compareEpisodeOfCareByDate = (
  eoc1: EpisodeOfCare,
  eoc2: EpisodeOfCare
) => {
  const status1 = getEpisodeOfCareStatus(eoc1);
  const status2 = getEpisodeOfCareStatus(eoc2);

  // Tiebreak on createdOn - incident.occurredOn is absent for patient EOCs
  // and incident.onsetWindow isn't a date at all.
  if (status1 === status2) {
    const createdOn1 = dayjs(eoc1.createdOn);
    const createdOn2 = dayjs(eoc2.createdOn);

    return createdOn1.diff(createdOn2);
  }

  return status1 < status2 ? -1 : 1;
};

export const sortEpisodeOfCareList = (episodeOfCareList: EpisodeOfCare[]) => {
  const res = [...episodeOfCareList];

  res.sort(compareEpisodeOfCareByDate);

  return res;
};
